import React, { Component } from 'react'
import styled from 'styled-components'
import theme from 'ui/styles/theme'
import easing from 'ui/styles/easing'

const TransitionPath = styled.path`
  transition: fill 0.3s ${easing.easeOutCubic};
`

export default class IconManagement extends Component {
  render() {
    const { hover, active } = this.props

    return (
      <svg
        width="52"
        height="55"
        viewBox="0 0 52 55" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <TransitionPath
            d="M43.663 28.79a1.594 1.594 0 0 0-1.282 2.54l-4.103 5.835a1.591 1.591 0 0 0-1.471.321l-3.93-2.643a1.594 1.594 0 1 0-3.146.16l-6.645 5.594a1.594 1.594 0 1 0 .803.874l6.505-5.476a1.588 1.588 0 0 0 1.923-.1l3.938 2.65a1.594 1.594 0 1 0 2.961-.652l4.176-5.94a1.594 1.594 0 1 0 .27-3.164M13.282 18.856h1.186v-7.048h-1.186zM16.394 11.578l-2.52-2.52-2.519 2.52-.838-.839 3.358-3.358 3.358 3.358-.839.839"
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
          />
          <TransitionPath
            d="M28.313 18.876h-9.76V17.69h9.76a3.985 3.985 0 0 0 3.98-3.98 3.968 3.968 0 0 0-3.82-3.977l-.522-.02-.046-.521c-.228-2.62-2.47-4.672-5.102-4.672l-.076.002-.44.01-.165-.347a5.15 5.15 0 0 0-4.632-2.933 5.103 5.103 0 0 0-3.994 1.916l-.29.36-.42-.193a5.08 5.08 0 0 0-2.134-.466 5.13 5.13 0 0 0-5.02 6.151l.14.694-.706.017a3.957 3.957 0 0 0-3.88 3.979 3.985 3.985 0 0 0 3.98 3.98h3.998v1.186H5.167A5.172 5.172 0 0 1 0 13.71c0-2.6 1.873-4.728 4.372-5.106a6.317 6.317 0 0 1 6.28-6.92c.764 0 1.507.134 2.214.4A6.278 6.278 0 0 1 17.49.066a6.344 6.344 0 0 1 5.53 3.272c2.98.105 5.509 2.34 6.003 5.254a5.15 5.15 0 0 1 4.456 5.118 5.172 5.172 0 0 1-5.166 5.166"
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
          />
          <TransitionPath
            d="M50.72 44.769a2.822 2.822 0 0 1-2.818 2.818H18.693a2.822 2.822 0 0 1-2.818-2.818V27.434a2.822 2.822 0 0 1 2.818-2.819h29.209a2.822 2.822 0 0 1 2.818 2.82v17.334zm-2.818-21.34H18.693a4.01 4.01 0 0 0-4.004 4.005V44.77a4.01 4.01 0 0 0 4.004 4.004h14.37v4.113h-4.75v1.186h10.512v-1.186h-4.577v-4.113h13.654a4.009 4.009 0 0 0 4.004-4.004V27.434a4.009 4.009 0 0 0-4.004-4.004z"
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
          />
        </g>
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/ProductsNew/IconManagement.js